import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';

import {branchInfo} from './branchReducers';

import {
  itemsFilter,
  menuGroups,
  menuItems,
  menuItemTypes,
  menuPresentation,
  selectedBusinessLunch,
  selectedItem,
  selectedItemInstructions,
  selectedItemSupplements
} from './menuReducers';
import {currentOrderItem, orderDateTime, orderInfo, orderItems, orderType} from './orderReducers';
import {costDelivery} from './costDeliveryReducers';
import {clientInfo} from './clientReducers';
import {
  branchMessageShown,
  currentDeliveryType,
  currentLanguageId,
  currentUiLanguageId,
  currentTableId,
  orderTips,
  orderGuidCode,
  generalErrorTranslationKey
} from './baseReducers';
import {valuecardItem, valuecardInfo, selectedValueCardBenefits, valueCardBenefitsResponse} from './valuecardReducers';
import {loading} from './loadingReducers';
import {currentPaymentType, paymentTypes} from './paymentReducers';
import {clientPaymentAmount, clientPaymentData, clientTips, clientTipType, payments} from './webPayReducers';

const createRootReducer = history => combineReducers({
  router: connectRouter(history),
  branchInfo,  
  menuItems,
  menuGroups,
  orderItems,
  clientInfo,
  itemsFilter,
  menuItemTypes,
  currentLanguageId,
  currentUiLanguageId,
  currentDeliveryType,
  selectedItem,
  selectedItemSupplements,
  selectedItemInstructions,
  selectedBusinessLunch,
  loading,
  paymentTypes,
  currentPaymentType,
  orderType,
  orderInfo,
  orderDateTime,
  costDelivery,
  payments,
  clientPaymentData,
  clientTips,
  clientPaymentAmount,
  clientTipType,
  currentOrderItem,
  generalErrorTranslationKey,
  currentTableId,
  orderTips,
  orderGuidCode,
  valuecardItem,
  valuecardInfo,
  selectedValueCardBenefits,
  valueCardBenefitsResponse,
  branchMessageShown,
  menuPresentation
});

export default createRootReducer;
